export default __webpack_public_path__ + "static/media/chooseOpp.09ea3c06.png";